import { diagnosisSchema } from '@billing/validation/diagnosis';
export interface Diagnosis {
  id: string;
  description: string;
  icd9: string;
}

export const isDiagnosis = (obj: any): obj is Diagnosis => {
  return diagnosisSchema.safeParse(obj).success;
};
